import React from "react";
import AvatarStep from "../../components/onboarding/_steps/AvatarStep";

const TestAvatar = () => {
	return (
		<div className="flex justify-center items-start h-screen w-screen max-h-screen max-w-screen">
			<div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/4 bg-white shadow-lg rounded-lg p-6 flex flex-col items-center space-y-4 w-11/12 max-w-sm">
				<AvatarStep quizWrapper={{ name: "iserba" }} />
			</div>
		</div>
	);
};

export default TestAvatar;
